import request from "../../services/request";
import { RTABAK_URLS } from "../../utils/urls";
// TO DO - get variations from context
export const AdminService = {
  getManufacturingCost: async () => {
    return request({
      baseURL: RTABAK_URLS.API.GetManufacturingCost,
      method: "GET",
    });
  },
  updateMannufacturingCost: async (mc: ManufacturingCost) => {
    return request({
      baseURL: RTABAK_URLS.API.GetManufacturingCost,
      method: "PUT",
      data: mc,
    });
  },
  deleteMannufacturingCost: async (mc: string) => {
    const data = { manufacturingCostId: mc };
    return request({
      baseURL: RTABAK_URLS.API.GetManufacturingCost,
      method: "DELETE",
      data,
    });
  },
  saveProduct: async (data: Product) => {
    return request({
      baseURL: RTABAK_URLS.API.PostProduct,
      method: "POST",
      data,
    });
  },
  saveImage: async (image: FormData) => {
    //Check this endpoint
    return request({
      baseURL: RTABAK_URLS.API.PostProductImage,
      method: "POST",
      data: image,
    }).then((r) => {
      return r;
    });
  },
  saveHeroImage: async (image: FormData) => {
    return request({
      baseURL: RTABAK_URLS.API.Hero,
      method: "POST",
      data: image,
    }).then((r) => {
      return r.json();
    });
  },
  saveVariant: async (data: Variation[]) => {
    return request({
      baseURL: RTABAK_URLS.API.PostVariations,
      method: "POST",
      data,
    });
  },
  updateProduct: async (data: Product) => {
    return request({
      baseURL: RTABAK_URLS.API.PostProduct,
      method: "PUT",
      data,
    });
  },
  updateVariations: async (data: Variation[]) => {
    return request({
      baseURL: RTABAK_URLS.API.PostVariations,
      method: "PUT",
      data,
    });
  },
  deleteProduct: async (data: Product) => {
    return request({
      baseURL: RTABAK_URLS.API.PostProduct,
      method: "DELETE",
      data,
    });
  },
  deleteVariation: async (data: Variation) => {
    return request({
      baseURL: RTABAK_URLS.API.PostVariations,
      method: "DELETE",
      data,
    });
  },
  deleteImage: async (data: {
    image: string;
    thumbnailUrl: string;
    _id?: string;
  }) => {
    return request({
      baseURL: RTABAK_URLS.API.PostProductImage,
      method: "DELETE",
      data,
    });
  },
  deleteHeroImage: async (data: { image: string }) => {
    return request({
      baseURL: RTABAK_URLS.API.Hero,
      method: "DELETE",
      data,
    });
  },
  updateCarouselOrder: async (data: any) => {
    return request({
      baseURL: RTABAK_URLS.API.Carousels,
      method: "PUT",
      data,
    });
  },
  createNewCategory: async (data: Category) => {
    return request({
      baseURL: RTABAK_URLS.API.GetCategorybyDepartment,
      method: "POST",
      data,
    });
  },
  deleteCategory: async (data: {
    department: string;
    value: string;
    id: string;
  }) => {
    return request({
      baseURL: RTABAK_URLS.API.GetCategorybyDepartment,
      method: "DELETE",
      data,
    });
  },
  updateCategory: async (data: Category) => {
    return request({
      baseURL: RTABAK_URLS.API.GetCategorybyDepartment,
      method: "PUT",
      data,
    });
  },
};
